import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDoor"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V20H22V22H2V20H4V2ZM7 11H10V13H7V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoor;
